import VueCookie from "vue-cookie";
import TripleDES from "@/utils/lib/crypto.js";
const cookieObj =
  VueCookie.get("cookieObj") !== null
    ? TripleDES.decode("token", JSON.parse(VueCookie.get("cookieObj")))
    : null;

const user = {
  namespaced: true,
  state: {
    // 用户ID
    userId: sessionStorage.getItem("userId")
      ? sessionStorage.getItem("userId")
      : VueCookie.get("cookieObj") !== null
        ? cookieObj.userId
        : "",
    // 用户Guid
    userGuid: localStorage.getItem("userguid")
      ? localStorage.getItem("userguid")
      : VueCookie.get("cookieObj") !== null
        ? cookieObj.userguid
        : "",

    realName: "",

    token: sessionStorage.getItem("token")
      ? sessionStorage.getItem("token")
      : VueCookie.get("cookieObj") !== null
        ? cookieObj.token
        : "",

    mobileNum: sessionStorage.getItem("phone")
      ? sessionStorage.getItem("phone")
      : VueCookie.get("cookieObj") !== null
        ? cookieObj.phone
        : "",

    accounttype: sessionStorage.getItem("type")
      ? sessionStorage.getItem("type")
      : VueCookie.get("cookieObj") !== null
        ? cookieObj.accounttype
        : 0,

    permission: JSON.parse(sessionStorage.getItem("p"))
      ? JSON.parse(sessionStorage.getItem("p"))
      : VueCookie.get("cookieObj") !== null
        ? cookieObj.permission
        : [],

    Owx: "",

    accountstatus: sessionStorage.getItem("accountstatus")
      ? sessionStorage.getItem("accountstatus")
      : VueCookie.get("cookieObj") !== null
        ? cookieObj.accountstatus
        : 0,

    showmsg: sessionStorage.getItem("showmsg")
      ? sessionStorage.getItem("showmsg")
      : VueCookie.get("cookieObj") !== null
        ? cookieObj.showmsg
        : "",

    permissionArray: sessionStorage.getItem("permissionArray")
      ? sessionStorage.getItem("permissionArray")
      : VueCookie.get("cookieObj") !== null
        ? cookieObj.permissionArray
        : [],

    wxopenid: sessionStorage.getItem("wxopenid")
      ? sessionStorage.getItem("wxopenid")
      : VueCookie.get("cookieObj") !== null
        ? cookieObj.wxopenid
        : "",

    wxunionid: sessionStorage.getItem("wxunionid")
      ? sessionStorage.getItem("wxunionid")
      : VueCookie.get("cookieObj") !== null
        ? cookieObj.wxunionid
        : "",
    // 运营商编码
    agentcode: sessionStorage.getItem("agentcode")
      ? sessionStorage.getItem("agentcode")
      : VueCookie.get("cookieObj") !== null
        ? cookieObj.agentcode
        : "",
    // 绑定了微信的账号
    wxgenerateid: sessionStorage.getItem("wxgenerateid")
      ? sessionStorage.getItem("wxgenerateid")
      : VueCookie.get("cookieObj") !== null
        ? cookieObj.wxgenerateid
        : "",

    // 商城版本
    mallver: sessionStorage.getItem("mallver")
      ? sessionStorage.getItem("mallver")
      : VueCookie.get("cookieObj") !== null
        ? cookieObj.mallver
        : "",
    isaccedit: sessionStorage.getItem("isaccedit")
      ? sessionStorage.getItem("isaccedit")
      : VueCookie.get("isaccedit") !== null
        ? cookieObj.isaccedit
        : "",
    maxopennum: sessionStorage.getItem("maxopennum")
      ? sessionStorage.getItem("maxopennum")
      : VueCookie.get("maxopennum") !== null
        ? cookieObj.maxopennum
        : "",
    opennum: sessionStorage.getItem("opennum")
      ? sessionStorage.getItem("opennum")
      : VueCookie.get("opennum") !== null
        ? cookieObj.opennum
        : "",
    guidetimes: 0,
    maxtokens: sessionStorage.getItem("maxtokens")
      ? sessionStorage.getItem("maxtokens")
      : VueCookie.get("maxtokens") !== null
        ? cookieObj.maxtokens
        : 0,
    usedtokens: 0,
  },
  mutations: {
    setUserId: (state, key) => {
      state.userId = key;
    },
    setUserGuid: (state, key) => {
      state.userGuid = key;
    },
    setRealName: (state, key) => {
      state.realName = key;
    },
    setToken: (state, key) => {
      state.token = key;
    },
    setMobileNum: (state, key) => {
      state.mobileNum = key;
    },
    setAccountType: (state, key) => {
      state.accounttype = key;
    },
    setPermission: (state, key) => {
      state.permission = key;
    },
    setOwx: (state, key) => {
      // console.log('判断是微信浏览器还是浏览器', key)
      state.Owx = key;
    },
    setAccountStatus: (state, key) => {
      state.accountstatus = key;
    },
    setShowMsg: (state, key) => {
      state.showmsg = key;
    },
    setPermissionArray: (state, key) => {
      state.permissionArray = key;
    },
    setWxOpenId: (state, key) => {
      state.wxopenid = key;
    },
    setWxUnionId: (state, key) => {
      state.wxunionid = key;
    },
    setAgentCode: (state, key) => {
      state.agentcode = key;
    },
    setWxgenerateId: (state, key) => {
      state.wxgenerateid = key;
    },

    setMallVer: (state, key) => {
      state.mallver = key;
    },
    setIsAccEdit: (state, key) => {
      state.isaccedit = key;
    },
    setMaxOpenNum: (state, key) => {
      state.maxopennum = key;
    },
    setOpenNum: (state, key) => {
      state.opennum = key;
    },
    setMaxToken: (state, key) => {
      state.maxtokens = key;
    }
  },
};

export default user;
